import React from 'react';

export default function Footer() {
  return (
    <>
      <style>
        {`
        footer {
          background-color: #050520;
          padding: 25px;
          font-family: Arial, sans-serif;
          border-top: 1px solid #e9ecef;
        }

        .footer-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 0px;
          text-align: end;
          line-height: 1.4;
        }

        .footer-links a {
          color: white;
          text-decoration: none;
          margin: 0 30px;
          font-size: 14px;
          transition: color 0.3s;
        }
          .footer-links{
          width: 100%;
          }
        .footer-links a:hover {
          color: #12A500;
        }
          .donate{
           width: 100%;
          }

        .donate-link {
       
          color: #12A500 !important;
          font-weight: bold;
        }
          .donate span{
          display: flex;
          gap: 5px;
          justify-content: flex-end;
          
          }
        @media (max-width: 768px) {
          footer {
            padding: 10px 0px 20px;
          }

          .footer-content {
            flex-direction: column;
            text-align: center;
          }

          .footer-links a {
            margin: 0 10px;
          }

          .donate {
            margin-top: 10px;
            font-size: 14px;
          }
            .donate span{
            width: fit-content;
            margin: 0 auto;
            justify-content: center;
            flex-direction: column;
            }
            .donate span a{
            width: fit-content;
            margin: 0 auto;
            }
        }
        `}
      </style>

      <footer className="footer-content">
        <div className="footer-links">
          <span style={{color: 'white'}}>3.rw &copy; 2025</span>
        </div>
        <div className="donate">
          <span style={{ color: 'white', fontWeight: 500 }}>
            <a
            target='_blank'
              href="/1/E2EE/index.html"
              className="donate-link"
              style={{ paddingBottom: '1px', borderBottom: '1px solid #12A500' }}
            >
              E2EE
            </a>
            {/* Big thanks to the{' '} */}
            <a
            target='_blank'
              href="/1/privacy-policy/index.html"
              className="donate-link"
              style={{ paddingBottom: '1px', borderBottom: '1px solid #12A500' }}
            >
              Privacy Policy
            </a>
            {/* Big thanks to the{' '} */}

          </span>
        </div>
      </footer>
    </>
  );
}
